const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');

const { truncateDecimal } = require('utilities/numberHelper');
// @ components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { CardPayLaterStep1 } = require('components/cards/cardPayLaterSteps/cardPayLaterStep1/cardPayLaterStep1');
const CardPayLaterStep2 = require('components/cards/cardPayLaterSteps/cardPayLaterStep2/cardPayLaterStep2');

class CardPayLater extends React.Component {
    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        const { immCard, setImportMaxMin } = this.props;
        const min = Math.max(25, truncateDecimal(immCard.getIn(['balanceDrawn', 'amount']) * 0.03));
        const max = immCard.getIn(['limit', 'amount']);
        setImportMaxMin(min, max);
    }

    onCancel() {
        const { history, immCard } = this.props;
        history.push(`/myprofile/cards/${immCard.get('cardId')}/details`);
    }

    render() {
        const {
            immCard,
            immCardPayLater,
            immGlobalVariables,
            onFinish,
            setVisibleStep,
            setWillCancel,
            validateStep

        } = this.props;
        const immSteps = immCardPayLater.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immCardPayLater.get('visibleStep');
        const wizardClass = 'card-pay-later__wizard';
        const immFinalButton = 'cardPayLater-payLater';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: onFinish,
            cancel: this.onCancel
        };
        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                showPreLeaveModal={true}
            >
                <WizardStep position="first" cancelButton={true} nextButton={true} >
                    <CardPayLaterStep1
                        immCardPayLater={immCardPayLater}
                        immCard={immCard}
                        immGlobalVariables={immGlobalVariables}
                        import={immSteps.get(0).get('import')}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                    isLoading={immCardPayLater.get('isFetching')}
                >
                    <CardPayLaterStep2
                        immCard={immCard}
                        immCardPayLater={immCardPayLater}
                        immGlobalVariables={immGlobalVariables}
                    />
                </WizardStep>
            </Wizard>
        )
    }
}

CardPayLater.propTypes = {
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object,
    immCardPayLater: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    setImportMaxMin: PropTypes.func.isRequired
}

module.exports = withRouter(CardPayLater);
